import { Lottie, type LottieProps } from 'lottie-react';

type LottieAnimationProps = Omit<LottieProps, 'src'> & {
  animationData: LottieProps['src'];
};

export const LottieAnimation = ({ animationData, ...props }: LottieAnimationProps) => (
  <Lottie src={animationData} autoplay {...props} />
);
